import React from 'react'

import { SidebarProvider, SidebarInset } from '@/components/ui/sidebar'
import Sidebar from '../components/Sidebar'
import Navbar from '../components/Navbar'
import Content from '../components/Content'
import Footer from '../components/Footer'

import Loader from '../components/Loader.tsx'

import { useAuth, useProjectRouteSync } from '../hooks'

const Dashboard = ({ children }) => {
  const { user } = useAuth()
  // Module pages resolve their project from me.currentProject, so a /project/:id
  // URL has to move that pointer before the page mounts.
  const { syncing } = useProjectRouteSync()

  if (user) {
    return (
      <SidebarProvider>
        <Sidebar />
        <SidebarInset>
          <Navbar subscription={user.organization.subscription} organizations={user.organizations} currentOrg={user.organization} />
          <Content>{syncing ? <Loader /> : children}</Content>
          <Footer />
        </SidebarInset>
      </SidebarProvider>
    )
  }

  return <Loader />
}

export default Dashboard
